module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.b45492d9.png";